import actionTypes from '../constants/action-types';

const undo = () => ({
  type: actionTypes.UNDO,
});

export default undo;
